module.exports = __webpack_public_path__ + "static/media/autokar3 (9).059a6979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar3 (9).jpg
// module id = 865
// module chunks = 0